<script setup>
import { isAvailableNow } from '@/utils/dates.js'

const { blocks } = defineProps({
  blocks: {
    type: Array,
    default: () => ([]),
  },
})

const availableBlocks = blocks.filter(block => isAvailableNow(block))
</script>

<template>
  <template v-for="(block, i) in availableBlocks" :key="i">
    <cms-breadcrumb
      v-if="block.__component === 'elemente.breadcrumb'"
      :class="block.dense ? 'mb-4' : 'mb-10'"
    />

    <cms-consent-map
      v-if="block.__component === 'elemente.map'"
      v-bind="block"
    />

    <cms-image-slider
      v-if="block.__component === 'elemente.slider'"
      v-bind="block"
    />

    <v-container
      v-if="block.__component === 'elemente.main-heading'"
      :fluid="block.fluid"
      class="py-0"
    >
      <cms-main-heading
        :custom-color="block.customColor"
        :type="block.type"
        :text="block.text"
        :primary="block.primaryColor"
        :dense="block.reducedVerticalSpace"
      />
    </v-container>

    <v-container
      v-if="block.__component === 'elemente.card-grid'"
      :fluid="block.fluid"
      :class="{
        'pa-0': block.fluid,
        'py-0 mb-15': !block.fluid,
      }"
    >
      <cms-card-grid
        :cards="block.imageCards"
        :is-gallery="block.gallery"
        :align="block.align"
      />
    </v-container>

    <cms-content-card
      v-if="block.__component === 'elemente.content-card'"
      v-bind="block"
    />

    <cms-simple-image
      v-if="block.__component === 'elemente.simple-image'"
      v-bind="block"
    />

    <cms-simple-content
      v-if="block.__component === 'elemente.simple-content'"
      v-bind="block"
    />

    <cms-expansion-panel
      v-if="block.__component === 'elemente.expansion-panel'"
      v-bind="block"
    />

    <cms-styled-image-grid
      v-if="block.__component === 'elemente.styled-image-grid'"
      v-bind="block"
    />

    <template v-if="block.__component === 'elemente.form'">
      <v-container class="py-0 mb-15">
        <cms-form-builder v-bind="block" />
      </v-container>
    </template>
  </template>
</template>
